import React, { Component } from 'react';
import loadScripts from '../../dassets/js/custom';
import { Link } from 'react-router-dom';

class Experience extends Component {
    componentDidMount() {
        loadScripts();
    }
    render() {
        return (
            <>
                {/* =================================
    Inner Header */}
                <div className="inner-header bg-light">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
                                <h1 className="breadcrumb-title mb-0">Our Experience</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
                                    <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
                                    <li className="breadcrumb-item"><span>Our Experience</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* =================================
  Inner Header */}

                <section className="space-ptb">
                    <div className="container">
                        <div className="row">
                            <div id='oe' className="col-12 mb-4 mb-md-5">
                                <div className='mb-4'>
                                    <h6>We acted as Issuing House/Joint Issuing House to:</h6>

                                    <div className="owl-carousel our-clients" data-nav-arrow="false" data-items="6" data-md-items="5" data-sm-items="4" data-xs-items="3" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="4000">
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Issuing House/Inland Bank.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Issuing House/Sovereign Trust Insurance Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Issuing House/BAICO Insurance.png")} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className='mb-4'>
                                    <h6>We acted as Merger/Financial Advisers to:</h6>
                                    <div className="owl-carousel our-clients" data-nav-arrow="false" data-items="6" data-md-items="5" data-sm-items="4" data-xs-items="3" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="4000">
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Financial Adviser/21st Century Technologies Limited.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Financial Adviser/Century Micro - Finance Bank Limited.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Financial Adviser/Custodian & Allied Insurance Limited.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Financial Adviser/Fire Equity & General Insurance Limited.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Financial Adviser/First Atlantic Bank Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Financial Adviser/Niger Delta Exploration and Production Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Financial Adviser/Niger Delta Petroleum Resources Limited.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Financial Adviser/Signal Insurance Company Limited.png")} alt="" />
                                        </div>
                                    </div>

                                </div>
                                <div className='mb-4'>
                                    <h6>Brokers to Public Offers:</h6>
                                    <div className="owl-carousel our-clients" data-nav-arrow="false" data-items="6" data-md-items="5" data-sm-items="4" data-xs-items="3" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="4000">
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/AfriBank.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/African Petroleum Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/Co - operative Development Bank Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/Federal Mortgage Bank of Nigeria.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/First Bank of Nigeria.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/Inland Bank.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/International Merchant Bank Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/MannyBank Plc----------Fidelity Bank.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/NAL Bank Plc----------Sterling Bank.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/Neimeth International Pharmaceuticals Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/PlatinumHabib Bank Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/Savannah Bank Nigeria Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/Sovereign Trust Insurance Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/Tropical Commercial Bank Plc.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Brokers/Universal Trust Bank Nigeria Plc---------Union Bank.png")} alt="" />
                                        </div>
                                    </div>

                                </div>
                                <div className='mb-4'>
                                    <h6>We also acted as Stockbrokers to the following Mergers:</h6>

                                    <div className="owl-carousel our-clients" data-nav-arrow="false" data-items="6" data-md-items="5" data-sm-items="4" data-xs-items="3" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="4000">
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Stockbroker Mergers/Confidence Insurance.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Stockbroker Mergers/GTB.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Stockbroker Mergers/Inland Bank.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Stockbroker Mergers/Prime Trust Insurance Limited.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Stockbroker Mergers/Sovereign Trust Insurance Plc.png")} alt="" />
                                        </div>
                                    </div>

                                </div>
                                <div className='mb-4'>
                                    <h6>Signature Verification and Sale of Shares:</h6>

                                    <div className="owl-carousel our-clients" data-nav-arrow="false" data-items="6" data-md-items="5" data-sm-items="4" data-xs-items="3" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="4000">
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Signature Verfication/AfriBank.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Signature Verfication/Ecobank.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Signature Verfication/Equatorial Trust Bank Limited.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Signature Verfication/Industrial and General Insurance Limited.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Signature Verfication/United Bank for Africa Plc.png")} alt="" />
                                        </div>
                                    </div>

                                </div>
                                <div className='mb-4'>
                                    <h6>Public Sector Transaction:</h6>

                                    <div className="owl-carousel our-clients" data-nav-arrow="false" data-items="6" data-md-items="5" data-sm-items="4" data-xs-items="3" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="4000">
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Public Sector/Bauchi State Government.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Public Sector/Borno State.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Public Sector/Lagos State.png")} alt="" />
                                        </div>
                                        <div className="item">
                                            <img className="img-fluid p-3" src={require("../../dassets/images/our_experience/Public Sector/Nigeria Social Insurance Trust Fund.png")} alt="" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default Experience;